<template>
<ul class="list-unstyled navigation" role="menu">
    <li :class="{ active: link.active }" v-for="(link, idx) in links" :key="idx" role="none">
      <a :href="link.href"
         :target="link.target"
         role="menuitem"
         :tabindex="show ? '0' : '-1'"
         @keydown="handleKeydown($event, idx)"
         @focus="handleFocus(idx)"
         @blur="handleBlur(idx)">
        <i :class="link.icon" v-if="link.icon" aria-hidden="true"></i>
        {{ link.text }}
      </a>
    </li>
</ul>
</template>

<script>
export default {
  name: "DropdownLinks",

  computed: {
    links() {
      return this.$parent.dropdownLinks;
    },

    show() {
      return this.$parent.show;
    }
  },

  methods: {
    handleKeydown(event, index) {
      const totalLinks = this.links.length;
      let nextIndex, prevIndex;

      switch(event.key) {
        case 'ArrowDown':
          event.preventDefault();
          nextIndex = (index + 1) % totalLinks;
          this.focusLink(nextIndex);
          break;

        case 'ArrowUp':
          event.preventDefault();
          prevIndex = index === 0 ? totalLinks - 1 : index - 1;
          this.focusLink(prevIndex);
          break;

        case 'Home':
          event.preventDefault();
          this.focusLink(0);
          break;

        case 'End':
          event.preventDefault();
          this.focusLink(totalLinks - 1);
          break;

        case 'Escape':
          event.preventDefault();
          this.$parent.close();
          break;
      }
    },

    focusLink(index) {
      const links = this.$el.querySelectorAll('a');
      if (links[index]) {
        links[index].focus();
      }
    },

    handleFocus(index) {
      // Update aria-activedescendant if needed
      const links = this.$el.querySelectorAll('a');
      links.forEach((link, i) => {
        if (i === index) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    },

    handleBlur(index) {
      // Optional: handle blur events if needed
    }
  }
};
</script>
